module.exports = __webpack_public_path__ + "media/images/lb/223-abee6cfc368a0615dd625e09a496c57a.svg";